@if ((customDescription | translate) !== customDescription) {
  <div class="rule_description">
    {{ customDescription | translate }}
  </div>
}
